import styled from "styled-components";
import { rawColors } from "../../../../design-system/tokens/colors";
import { controlSize } from "../../../../design-system/tokens/controlSizes";
import { spacing } from "../../../../design-system/tokens/spacing";
import { borderRadius } from "../../../../design-system/tokens/borders";
import { typographyMixin } from "../../../../design-system/tokens/typography";
import {
  BigPreview,
  Thumbnail,
  ThumbnailStrip,
  TemplateDropdownWrapper,
} from "../ExportStoryModal.styles";

/** Anchors the absolutely-positioned dropdown menu under its trigger. */
export const ThemeDropdownAnchor = styled.div`
  position: relative;
`;

/** The existing dropdown trigger, rendered as a real button (keyboard + disabled). */
export const ThemeDropdownTrigger = styled(TemplateDropdownWrapper)`
  width: 100%;
  text-align: left;
  font: inherit;
  min-height: ${controlSize.field.md};
  border-radius: ${borderRadius[10]};

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

/** F18: the preview sits in a soft grey tile under the Theme field. */
export const PreviewTile = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 10.5rem;
  padding: ${spacing[3]};
  border-radius: ${borderRadius.xl};
  background-color: ${rawColors.grey[50]};
`;

/** A deck can have many pages — scroll the strip instead of squashing it. */
export const PageStrip = styled(ThumbnailStrip)`
  overflow-y: auto;
`;

/**
 * The shared Thumbnail stretches to share the strip's height, which squashes
 * a long deck into slivers — keep each page at the deck's 16:9 and scroll.
 */
export const PageThumbnail = styled(Thumbnail)`
  flex: 0 0 auto;
  width: 100%;
  aspect-ratio: 16 / 9;
  padding: 0;
  font: inherit;
`;

/** Rendered page at the preview's size; the image keeps its own aspect ratio. */
export const PageStage = styled(BigPreview)`
  padding: 0;
  align-items: center;
  justify-content: center;
`;

export const PreviewMessage = styled.p`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: ${spacing[2]};
  margin: 0;
  padding: ${spacing[4]};
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
  text-align: center;
`;

export const ThemeError = styled.p`
  margin: ${spacing[1]} 0 0;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.accent.red500};
`;
